import { downgradeWorkspaces } from "@features/workspaces";
import { downgradeSimpleReport } from "@features/simple-report";
import { downgradeDashboards } from "@features/dashboards";

export function downgradeModules() {
    downgradeWorkspaces();
    downgradeSimpleReport();
    downgradeDashboards();
}
